import { Component, OnInit } from '@angular/core';
import { AlertComponent, AlertModel, ALERT_TYPE } from '../shared/alert/alert.component';
import { SessionStorageService } from 'src/app/auth/services/session.service';
import { VersionInfoService } from 'src/app/services/versionInfo/versioninfo.service';
import * as moment from 'moment';


@Component({
  selector: 'app-versionInfo',
  templateUrl: './versionInfo.component.html',
  styleUrls: ['./versionInfo.component.css']
})

export class VersionInfoComponent implements OnInit {

  public title: string = "LISTAR VERSIONES";

  public alertMessage: AlertModel = new AlertModel;
  public alertConfirmEvent: Function;
  public loading: boolean;
  public versionData:any = [];


  constructor(private versionInfoService: VersionInfoService,
    private sessionStorageService: SessionStorageService ) {
      //this.sessionStorageService.currentSession.user.roles.includes("AMX_INT_ADMIN")
     }
  

  ngOnInit(): void {

    this.loadListDatabase();
  }

  loadListDatabase(){

    this.loading = true;
    this.versionInfoService.getListDatabase().subscribe(
      response => {
        if (response.status == 200 && response.body != null) {
          let data = response.body;
          this.versionData = Object.assign([], data['data']);
          this.versionData.BUILD_DATE = moment(this.versionData.BUILD_DATE).format("DD/MM/YYYY");
          this.loading = false;

        }
        else if( response.status == 204 ){
          this.alertMessage = new AlertModel( "No se encontraron registros con los datos ingresados.",this.title, true, ALERT_TYPE.INFO);
        }else{
          this.alertMessage = new AlertModel( "Hubo un inconveniente al obtener la información, inténtalo nuevamente.",this.title, true,"WARNING");
        }
        this.loading = false;
      },
      error => {
        console.error(error);
        this.loading = false;
        this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true, "ERROR");
        throw error;
      }
    );

  }

}

